import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import CopyableValue from "./CopyableValue";
import {
  getAuditActionLabel,
  getAuditEntityLabel,
} from "../constants/reportEnums";

const formatJson = (value) => {
  if (!value) return "—";
  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch {
    return value;
  }
};

const Field = ({ label, children }) => (
  <Grid item xs={12}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Box sx={{ mb: 1.5 }}>{children}</Box>
  </Grid>
);

const formatDate = (value) =>
  value ? new Date(value).toLocaleString("fa-IR") : "—";

const AuditLogDetailDialog = ({ open, onClose, data }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle>جزئیات لاگ #{data?.id ?? ""}</DialogTitle>
    <DialogContent dividers>
      {data ? (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary">
              نوع موجودیت
            </Typography>
            <Box sx={{ mb: 1.5 }}>
              <Chip size="small" label={getAuditEntityLabel(data.entityType)} />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary">
              عملیات
            </Typography>
            <Box sx={{ mb: 1.5 }}>
              <Chip size="small" label={getAuditActionLabel(data.actionType)} />
            </Box>
          </Grid>
          <Field label="شناسه موجودیت">
            <CopyableValue value={data.entityId} />
          </Field>
          <Field label="کاربر عامل">
            <CopyableValue value={data.actorUserId} />
          </Field>
          <Field label="تاریخ">
            <Typography variant="body2">{formatDate(data.changedAt)}</Typography>
          </Field>
          <Field label="توضیحات">
            <Typography variant="body2">{data.summary || "—"}</Typography>
          </Field>
          <Field label="مقدار قبلی">
            <Typography
              variant="body2"
              component="pre"
              sx={{
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                fontFamily: "monospace",
                fontSize: 12,
                m: 0,
                p: 1,
                bgcolor: "grey.50",
                borderRadius: 1,
              }}
            >
              {formatJson(data.beforeDataJson)}
            </Typography>
          </Field>
          <Field label="مقدار جدید">
            <Typography
              variant="body2"
              component="pre"
              sx={{
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                fontFamily: "monospace",
                fontSize: 12,
                m: 0,
                p: 1,
                bgcolor: "grey.50",
                borderRadius: 1,
              }}
            >
              {formatJson(data.afterDataJson)}
            </Typography>
          </Field>
        </Grid>
      ) : null}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>بستن</Button>
    </DialogActions>
  </Dialog>
);

export default AuditLogDetailDialog;
